// extracted by mini-css-extract-plugin
var _1 = "RequestTableRow-moduleRequestTableRow__EmLpe TableComponent-modulerow__xPAo4";
export { _1 as "RequestTableRow" }
